import { render, staticRenderFns } from "./UploadIdentification.vue?vue&type=template&id=537dce12&scoped=true&"
import script from "./UploadIdentification.vue?vue&type=script&lang=js&"
export * from "./UploadIdentification.vue?vue&type=script&lang=js&"
import style0 from "./UploadIdentification.vue?vue&type=style&index=0&id=537dce12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dce12",
  null
  
)

export default component.exports